import { MerchantId, SetHeaderService } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import service from "../baseHttpService";

class ProductService {
  DoGetAllProductTemplate(isUseMainDatabase = false) {
    const _input = {
      merchantId: MerchantId(),
      language: i18n.locale,
      isUseMainDatabase: isUseMainDatabase,
    };
    return service.peakExportAPI
      .post("/api/Product/GetAllProductTemplate", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
}

export default new ProductService();
